import { useEffect } from 'react';
import { useSWRConfig } from 'swr';
import { useSession } from 'next-auth/react';


/**
 * @description Hook that revalidates the SWR cache when the tab is refocused if the session
 * is not active (user logged out). This ensures the cache is cleared when authentication state changes.
 */
export const useRevalidateOnRefocus = () => {
  const { mutate: globalMutate } = useSWRConfig();
  const { status } = useSession();

  // Revalidate if session is not active (unauthenticated) - clear cache on logout
  const shouldRevalidate = status === 'unauthenticated';

  useEffect(() => {
    // when tab is refocused, run the callback
    const tabFocusCallback = () => {
      if (document.visibilityState === 'visible' && shouldRevalidate) {
        void globalMutate(
          () => true, // which cache keys are updated => all of them
          undefined, // update cache data to `undefined`
        );
      }
    };

    // Add event listener
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', tabFocusCallback, false);
    }

    // Cleanup the effect and remove the event listener
    return () => {
      if (typeof document !== 'undefined') {
        document.removeEventListener('visibilitychange', tabFocusCallback, false);
      }
    };
  }, [globalMutate, shouldRevalidate]);
};
